"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FollowingRoute = exports.FollowingRouteDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var use_active_person_1 = require("../../../hooks/use-active-person");
var use_entity_definition_named_1 = require("../../../hooks/use-entity-definition-named");
var use_icons_1 = require("../../../hooks/use-icons");
var use_lang_1 = require("../../../hooks/use-lang");
var icon_title_1 = require("../../elements/icon-title");
var platform_activity_entry_card_1 = require("../../entities/platform-activity-entry-card");
var wait_message_1 = require("../../elements/wait-message");
var loading_layout_1 = require("../../elements/loading-layout");
var client_1 = require("@apollo/client");
var lodash_1 = require("lodash");
var react_infinite_scroll_hook_1 = __importDefault(require("react-infinite-scroll-hook"));
var person_details_banner_1 = require("../../entities/person-details-banner");
var app_loader_1 = require("../../app/app-loader");
var graphql_1 = require("../../../utils/graphql");
var LATEST_QUERY = (0, graphql_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query LatestQuery($id: ID!, $input: PlatformActivityInput) {\n    person(id: $id) {\n      id\n      name\n      followingPlatformActivity(input: $input) { \n        meta {\n          total\n          count\n        }\n        results { \n          id date action\n          person { id name slug position isMember hasAccount organisation { id name slug location { id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand } } } openGraph { id image { id url } } photo { id url thumbnails { id full { id url width height } } } location { id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand } } }\n          comments { \n            id name slug created isWriteable description { id text html }\n            createdBy { \n              id name slug position organisation { id slug name } photo { id url }\n              location { id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand } }\n            }\n            replies { id name slug isWriteable created description { id text html }\n              createdBy { id name slug position organisation { id slug name } photo { id url } \n                location { id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand } }\n              }\n            }\n          }\n          entity { id name slug created openGraph { id title description { id text plain plainTruncated: plain(truncate: { words: 25 }) } date url author image { id url } } }\n          sourceEntity { id name slug created openGraph { id title description { id text plain plainTruncated: plain(truncate: { words: 25 }) } date url author image { id url } } }\n          relationship { id slug name }\n        }\n      }\n    }\n  }\n  "], ["\n  query LatestQuery($id: ID!, $input: PlatformActivityInput) {\n    person(id: $id) {\n      id\n      name\n      followingPlatformActivity(input: $input) { \n        meta {\n          total\n          count\n        }\n        results { \n          id date action\n          person { id name slug position isMember hasAccount organisation { id name slug location { id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand } } } openGraph { id image { id url } } photo { id url thumbnails { id full { id url width height } } } location { id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand } } }\n          comments { \n            id name slug created isWriteable description { id text html }\n            createdBy { \n              id name slug position organisation { id slug name } photo { id url }\n              location { id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand } }\n            }\n            replies { id name slug isWriteable created description { id text html }\n              createdBy { id name slug position organisation { id slug name } photo { id url } \n                location { id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand } }\n              }\n            }\n          }\n          entity { id name slug created openGraph { id title description { id text plain plainTruncated: plain(truncate: { words: 25 }) } date url author image { id url } } }\n          sourceEntity { id name slug created openGraph { id title description { id text plain plainTruncated: plain(truncate: { words: 25 }) } date url author image { id url } } }\n          relationship { id slug name }\n        }\n      }\n    }\n  }\n  "])));
exports.FollowingRouteDefaultProps = {};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding: 0 ", ";\n    padding-top: 2px;\n  "], ["\n    padding: 0 ", ";\n    padding-top: 2px;\n  "])), theme_1.theme.UNIT(3))
});
var InfiniteContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-top: ", ";\n    display: flex;\n    flex-direction: column;\n  "], ["\n    margin-top: ", ";\n    display: flex;\n    flex-direction: column;\n  "])), theme_1.theme.UNIT(1))
});
var ItemsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin-left: ", ";\n    ", ";\n    padding-left: ", ";\n    padding-top: ", ";\n  "], ["\n    margin-left: ", ";\n    ", ";\n    padding-left: ", ";\n    padding-top: ", ";\n  "])), theme_1.theme.UNIT(5, -1), theme_1.theme.V_DOT_BG('line-mid'), theme_1.theme.UNIT(1), theme_1.theme.UNIT(2))
});
var ItemStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    margin-bottom: ", ";\n\n    ", "\n  "], ["\n    margin-bottom: ", ";\n\n    ", "\n  "])), theme_1.theme.UNIT(9), function (_a) {
    var isFirst = _a.isFirst,
      showingSourceEntity = _a.showingSourceEntity;
    return !isFirst && showingSourceEntity && (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      margin-top: ", ";\n    "], ["\n      margin-top: ", ";\n    "])), theme_1.theme.UNIT(15));
  })
});
var WaitMessageStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(25)),
  tablet: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    margin-top: 0;\n  "], ["\n    margin-top: 0;\n  "])))
});
var LoadingLayoutStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var WaitMessageContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    max-width: ", ";\n    margin: 0 auto;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  "], ["\n    max-width: ", ";\n    margin: 0 auto;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  "])), theme_1.theme.MAX('content-width'))
});
var TitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    padding: ", ";\n    font-weight: 500;\n    text-transform: uppercase;\n  "], ["\n    padding: ", ";\n    font-weight: 500;\n    text-transform: uppercase;\n  "])), theme_1.theme.UNIT(3))
});
var BannerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    border-bottom: 1px solid ", ";\n  "], ["\n    border-bottom: 1px solid ", ";\n  "])), theme_1.theme.COLOR('line-semi-subtle'))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled_components_1.default.div(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Title: (0, styled_components_1.default)(icon_title_1.IconTitle)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  InfiniteContainer: styled_components_1.default.div(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), InfiniteContainerStyles),
  Banner: (0, styled_components_1.default)(person_details_banner_1.PersonDetailsBanner)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), BannerStyles),
  Items: styled_components_1.default.div(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), ItemsStyles),
  Item: (0, styled_components_1.default)(platform_activity_entry_card_1.PlatformActivityEntryCard)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), ItemStyles),
  WaitMessageContainer: styled_components_1.default.div(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), WaitMessageContainerStyles),
  WaitMessage: (0, styled_components_1.default)(wait_message_1.WaitMessage)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), WaitMessageStyles),
  LoadingLayout: (0, styled_components_1.default)(loading_layout_1.LoadingLayout)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), LoadingLayoutStyles)
};
var FollowingRoute = function (props) {
  var className = props.className;
  var t = (0, use_lang_1.useLang)();
  var person = (0, use_active_person_1.useActivePerson)().person;
  var variables = {
    id: person.id,
    input: {
      limit: 10
    }
  };
  var definition = (0, use_entity_definition_named_1.useEntityDefinitionNamed)('Person');
  var _a = (0, client_1.useQuery)(LATEST_QUERY, {
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'network-only',
      variables: variables
    }),
    data = _a.data,
    error = _a.error,
    loading = _a.loading,
    fetchMore = _a.fetchMore;
  var resultsKey = "".concat(definition.singleTypeName);
  var resultsPath = "".concat(definition.singleTypeName, ".followingPlatformActivity");
  var items = (0, lodash_1.get)(data, "".concat(resultsPath, ".results"), []);
  var meta = (0, lodash_1.get)(data, "".concat(resultsPath, ".meta"), {
    count: 0,
    total: 0
  });
  var hasNextPage = meta.total > items.length;
  var fetchMoreParams = {
    variables: __assign(__assign({}, variables), {
      input: __assign(__assign({}, variables.input), {
        skip: items.length
      })
    }),
    updateQuery: function (prev, _a) {
      var _b;
      var fetchMoreResult = _a.fetchMoreResult;
      if (!fetchMoreResult) return prev;
      var resultPrev = (0, lodash_1.get)(prev, resultsKey, {
        results: []
      });
      var result = (0, lodash_1.get)(fetchMoreResult, resultsPath, {
        results: []
      });
      var prevResults = (0, lodash_1.get)(prev, "".concat(resultsPath, ".results"), []);
      var newResult = (_b = {}, _b[resultsKey] = __assign(__assign({}, resultPrev), {
        followingPlatformActivity: __assign(__assign({}, resultPrev.followingPlatformActivity), {
          results: __spreadArray(__spreadArray([], __read(prevResults), false), __read(result.results), false)
        })
      }), _b);
      return newResult;
    }
  };
  var onLoadMore = function () {
    fetchMore(fetchMoreParams);
  };
  // console.log(data);
  var Icons = (0, use_icons_1.useIcons)();
  var _b = __read((0, react_infinite_scroll_hook_1.default)({
      loading: loading,
      hasNextPage: hasNextPage,
      onLoadMore: onLoadMore,
      rootMargin: '0px 0px 100px 0px'
    }), 2),
    sentryRef = _b[0],
    rootRef = _b[1].rootRef;
  var isFirstSourceEntity = true;
  var lastSourceEntityId;
  return react_1.default.createElement(My.Container, null, react_1.default.createElement(My.InfiniteContainer, {
    ref: rootRef
  }, react_1.default.createElement(My.Body, null, react_1.default.createElement(My.Title, {
    size: "small",
    icon: Icons.DotHeartCircle
  }, t('Latest Updates'), ":"), loading && items.length === 0 ? react_1.default.createElement(app_loader_1.AppLoader, null) : react_1.default.createElement(My.Items, null, items.map(function (item) {
    var currentSourceEntityId = item.sourceEntity && item.sourceEntity.id;
    var isFirst = isFirstSourceEntity;
    var showSourceEntity = lastSourceEntityId !== currentSourceEntityId;
    lastSourceEntityId = currentSourceEntityId;
    isFirstSourceEntity = false;
    return react_1.default.createElement(My.Item, {
      isFirst: isFirst,
      showingSourceEntity: showSourceEntity,
      showSourceEntity: showSourceEntity,
      key: item.id,
      entry: item
    });
  })), (loading || hasNextPage) && react_1.default.createElement(My.WaitMessageContainer, {
    ref: sentryRef
  }, react_1.default.createElement(My.WaitMessage, {
    loading: loading
  }, t('Loading. Please wait...'))))));
};
exports.FollowingRoute = FollowingRoute;
exports.FollowingRoute.defaultProps = exports.FollowingRouteDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23;